import React from "react";
import ReactDOM from "react-dom";
// Rebuild forced by Antigravity
import App from "./App";
import { polyfill } from "seamless-scroll-polyfill";
import './index.css';
polyfill();

// Initialize dark mode from localStorage
try {
  const darkMode = window.localStorage.getItem('dark_mode');
  if (darkMode === '"true"' || darkMode === 'true') {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
} catch (e) {
  console.error("Error initializing dark mode", e);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
